import { ComponentType } from 'react';
import classNames from 'classnames';

import { EmojiHalfsadOutlinedSize24, MagnifierOutlinedSize24 } from '@hh.ru/magritte-ui-icon/variants/icon';
import { SelectEmptyHintProps } from '@hh.ru/magritte-ui-select/types';
import { VSpacing } from '@hh.ru/magritte-ui-spacing';
import { Title } from '@hh.ru/magritte-ui-title';
import { Text } from '@hh.ru/magritte-ui-typography';

import styles from './select-empty-hint.less';

export const SelectEmptyHint: ComponentType<SelectEmptyHintProps> = ({ title, titleElement, description, type }) => {
    return (
        <div className={styles.selectEmptyHint}>
            {type === 'init' && (
                <div className={classNames(styles.icon, styles.iconInit)}>
                    <MagnifierOutlinedSize24 />
                </div>
            )}
            {type === 'emptySearch' && (
                <div className={classNames(styles.icon, styles.iconSearch)}>
                    <EmojiHalfsadOutlinedSize24 />
                </div>
            )}

            <VSpacing default={32} />
            <Title Element={titleElement} size="small">
                {title}
            </Title>
            <VSpacing default={8} />
            {Boolean(description) && (
                <Text typography="paragraph-2-regular" style="secondary">
                    {description}
                </Text>
            )}
        </div>
    );
};
